import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
	changeDateFormat,
	generateRandomString,
	onErrorImageLoad,
	STATIC_SET_CONSTANTS,
	toOrdinalSuffix
} from '@utils/Util';

const OrderCard = ({ details, orderStatus }) => {
	const navigate = useNavigate();
	const onRedirectToPage = () => {
		if (orderStatus === 'APPROVED') return navigate(`/orders/view/${details.orderId}`);
		return navigate(`/order/request/${details.orderId}`);
	};

	const getOrderImages = (orderDetails) => {
		const orderProductImages = [];
		const orderProducts = orderDetails?.orderProductList || [];
		orderProducts.forEach((product) => {
			if (
				product.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT &&
				product.setMemberList &&
				product.setMemberList.length > 0
			) {
				return product?.setMemberList.forEach((member) => {
					orderProductImages.push(member?.image);
				});
			} else {
				orderProductImages.push(product?.image);
			}
		});
		return orderProductImages;
	};

	const renderOrderImage = (imageSrc) => {
		if (imageSrc) {
			return (
				<img src={imageSrc} alt="design" onError={(e) => onErrorImageLoad(e, imageSrc, 'product')} />
			);
		} else {
			return <img src={`${process.env.PUBLIC_URL}/icons/image-default-bg.svg`} alt="design" />;
		}
	};
	return (
		<div className="sample-single-item" onClick={() => onRedirectToPage()}>
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-10 col-xl-8 pl-0">
						<div className="order-card-items">
							<div className="single-order-card cursor-pointer ">
								<div className="design-images">
									{renderOrderImage(getOrderImages(details)[0])}
									{renderOrderImage(getOrderImages(details)[1])}
									{renderOrderImage(getOrderImages(details)[2])}
									{renderOrderImage(getOrderImages(details)[3])}
								</div>
								<div className="order-details">
									<div className="po-numbers">
										<div className="pos">
											<span className="regular-14">
												{details?.title || details?.name}
											</span>
											<span className="regular-14 gray_dark_02">
												&nbsp;({details?.orderRefNumber})
											</span>
										</div>
									</div>
									<ul className="order-quantity-details d-flex">
										<li>{details?.totalStyles} Styles</li>
										<li>{details?.orderQuantity} units</li>
										<li>${details?.orderValue}</li>
									</ul>
									<div className="delivery-date-status">
										<span className="weight-300">ETD </span>
										<span className="date-info">
											<span className="remaining-days">
												{changeDateFormat(details?.endDate, 'YYYY/MM/DD', 'DD MMM')}
												<img
													src={`${process.env.PUBLIC_URL}/icons/status-ongoing.svg`}
													className="ml-1"
													alt
												/>
											</span>
											<div className="etd-dates shadow-2dp">
												{details?.deliveryDateList?.map((item, idx) => (
													<ul
														className="start"
														key={`${generateRandomString}-${idx}`}
													>
														<li>{toOrdinalSuffix(idx + 1)} ETD:</li>
														<li>
															{changeDateFormat(
																item,
																'YYYY-MM-DD',
																'DD MMM, YYYY'
															)}
														</li>
													</ul>
												))}
											</div>
										</span>
									</div>
									<div className="brand-and-logo d-flex justify-content-between align-items-center">
										<div>
											{details?.brandResponse ? (
												<span className="brand-common-design mt-3">
													{details?.brandResponse?.name}
												</span>
											) : (
												''
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-2 col-xl-4">
						<div className="sample-status">
							<span className="status">Order</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OrderCard;
